<template>
  <q-btn
    v-if="isGranted('IMPORT_POSTS')"
    label="Import Posts"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Platform } from '@/social/types';
import openModal from '@/components/modal';
import { isGranted } from '@/social/auth';
import ImportPostsModal from './ImportPostsModal.vue';

export default defineComponent({
  props: {
    platform: {
      type: Object as () => Platform,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
  },
  methods: {
    isGranted,
    openModal(): void {
      const config = {
        parent: this,
        platform: this.platform,
        clientId: this.clientId,
      };
      openModal(ImportPostsModal, config);
    },
  },
});
</script>
